import axios from 'axios';
import React, { useEffect, useState } from 'react'
import '../../Track.css';
import Modal from 'react-modal';
import { Rating } from 'react-simple-star-rating'
import { Link, useSearchParams } from 'react-router-dom';
import banner from '../../images/banners/login.jpg'
import full_circle from '../../images/full_circle.png'
import one_circle from '../../images/one_circle.png'
import two_circle from '../../images/two_circle.png'
import three_circle from '../../images/three_circle.png'
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../api';

export default function Track() {
    const [rating1, setRating] = useState({
        awbno: '',
        rate: '',
        comment: ''
    }) // initial rating value

    const [comment, setcomment] = useState('')

    function handleRating(rate) {
        setRating({ ...rating1, awbno: awb, rate: rate })

    }

    const [awb, setawb] = useState()
    const [trackhist, settrackhist] = useState(false)
    const [trackdetails, settrackdetails] = useState([])
    let finalsts = [];
    const [showModal, setShowModal] = useState(false);



    const [circleimage, setcircleimage] = useState(`${process.env.PUBLIC_URL}images/full_circle.png`)

    const [awbcurrent, setawbcurrent] = useState()
    const [lateststs, setlateststs] = useState()
    function getTracking(event) {
        event.preventDefault();
        fetch(`${BACKEND_URL}/tracking`, {
            method: 'POST', // Specify the method
            headers: {
                'Content-Type': 'application/json', // Set the content type
            },
            body: JSON.stringify({
                awbno: awb
            }), // Convert the data to JSON
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json(); // Parse the JSON from the response
            })
            .then((data) => {
                if (data.description === "Success") { // Use === for comparison
                    settrackhist(true);
                    settrackdetails(data.trackList.reverse());
                    if (trackdetails) {
                        setawbcurrent(awb);
                        let count = data.trackList.length;
                        let finalsts = data.trackList[0];
                        setlateststs(finalsts.Status);
                        if (finalsts.StatusCode === "POD") {
                            console.log('full');
                            setcircleimage(full_circle);
                        } else if (finalsts.StatusCode === "C") {
                            console.log('two');
                            setcircleimage(two_circle);
                        } else if (finalsts.StatusCode === "N") {
                            console.log('one');
                            setcircleimage(one_circle);
                        } else {
                            console.log('three');
                            setcircleimage(three_circle);
                        }
                    }
                }
            })
            .catch((error) => console.log(error.message));
    }

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [mailmsg, setmailmsg] = useState()
    const setModalIsOpenToTrue = () => {
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    function sendRating() {
        fetch(`${BACKEND_URL}/sendRating`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // Set the content type to JSON
            },
            body: JSON.stringify(rating1) // Convert the data to a JSON string
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json(); // Parse the JSON from the response
            })
            .then((data) => {
                setmailmsg(data.message); // Set the mail message from the response
            })
            .catch((err) => console.log(err))// Handle errors
    }

    function gettrackdate(trackdate) {
        let myDate = new Date(trackdate);
        let noTime = ` ${myDate.getMonth() + 1}/${myDate.getDate()}/${myDate.getFullYear()}`
        return noTime
    }
    return (
        <div className="track">
            <Helmet>
                <title>Shypv | Track</title>
            </Helmet>
            <Modal isOpen={modalIsOpen} ariaHideApp={false}>
                <button onClick={setModalIsOpenToFalse}>x</button>
                <>
                    <div className="container">
                        <div className="row ratepop">
                            <h3>Rate your delivery experience</h3>
                            <h2>today</h2>
                            <p>How was the service you received for your shipment?</p>
                            <Rating onClick={handleRating} ratingValue={rating1.rate} />
                            <textarea className=" form-control" value={rating1.comment} onChange={(e) => setRating({ ...rating1, comment: e.target.value })} rows="4" cols="20" id="" placeholder="your comment" />
                            <div className="remind_later">
                                {/* <a href="javascript:void(0)" id="remindLater" className="remind">Remind me later</a>  */}
                                <a id="getRating" className="send_btn" onClick={sendRating}>Send</a>
                                <p style={{ textAlign: "center" }}>{mailmsg}</p>
                            </div>
                        </div>
                    </div>

                </>
            </Modal>

            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" />
            <link href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,500;0,600;0,700;1,500&display=swap" rel="stylesheet" />
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 your_business text-center track-parcel">
                            <div className="business_content">
                                <h1 className="mainhead">Track Your Parcel</h1>

                            </div>
                            <h3 style={{ textAlign: "center" }}>Got a parcel to track?</h3>
                            <div className="formtrack">
                                <form name="tracking" method="get" id="tracking_track" action="#">
                                    <ul className="business_region">
                                        <li>
                                            <input required id="TrackingCode" onChange={(e) => setawb(e.target.value)} className="form-control" name="awbno" placeholder="Tracking number" type="text" />
                                        </li>

                                        <li><button className="btn form-control trackbtn noradius" type="submit" onClick={e => getTracking(e)} style={{ minWidth: " 100%", borderRadius: "0px !important" }}>Track</button></li>
                                    </ul>
                                </form>
                            </div>

                            {/* <Link to="/collect-or-drop-off-parcel/" className="masthead__findtrack">+ COLLECT YOUR PARCEL</Link> */}
                        </div>
                    </div>
                </div>
            </section>

            <div className="pages_content">
                <div className="container">

                    {
                        trackhist && (

                            <div className="row">

                                <div id="primary" className="content-area" style={{ float: 'left', width: '100%' }}>
                                    <div className="delivery-tracking">
                                        <div className="time-sutes">
                                            <h3>Delivery Tracking</h3>
                                            <p>Keep track of your parcel at all times.</p>
                                            <div className="box-time"><span>{awbcurrent}</span>
                                            </div>
                                        </div>
                                        <div className="circle-sec col-md-12 col-sm-12"><div className="circle_status">
                                            <div className="circle-img">
                                                <noscript>&lt;<img src="" />
                                                </noscript>
                                                <img className=" lazyloaded" src={circleimage} data-src={circleimage} />
                                            </div>
                                            <div className="status-driver-content"><div className="status-driver"><p>Status</p>
                                                <span>{lateststs}</span></div></div></div></div><div className="parcel-table">
                                            <div className="Parcel-box">
                                                <h3>Parcel History</h3>
                                                <p>Historical status information for Parcel Number {awb}</p>
                                                <div className="table-responsive">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <th>Received By/Remark</th>
                                                                <th width={125}>Date</th>
                                                                <th width={250}>Time</th>
                                                                <th width={285}>Description</th>
                                                            </tr>
                                                            {
                                                                trackdetails.map((track, i) => (
                                                                    i == 0 ? (
                                                                        <tr key={i} style={{ fontWeight: 'bold' }}>
                                                                            <td> {track.Status} </td>
                                                                            <td>{gettrackdate(track.TransDate)}</td>
                                                                            <td> {track.TransTime}</td>
                                                                            <td> {track.StatusCode}</td>
                                                                        </tr>
                                                                    ) : (
                                                                        <tr key={i} >
                                                                            <td> {track.Status} </td>
                                                                            <td>{gettrackdate(track.TransDate)}</td>
                                                                            <td> {track.TransTime}</td>
                                                                            <td> {track.StatusCode}</td>
                                                                        </tr>
                                                                    )

                                                                ))
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="btn-rate">
                                                <a data-fancybox data-src="#hidden-content" onClick={setModalIsOpenToTrue} className="rate-delivery" style={{ cursor: "pointer" }}>Rate My Delivery</a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        )
                    }
                </div>
            </div>
        </div>
    )

    function Ratepop() {
        return (
            <>
                <div className="container">
                    <div className="row ratepop">
                        <h3>Rate your delivery experience</h3>
                        <h2>today</h2>
                        <p>How was the service you received for your shipment?</p>
                        <Rating onClick={handleRating} ratingValue={rating1.rate} />
                        <textarea className=" form-control" value={rating1.comment} onChange={(e) => setRating({ ...rating1, comment: e.target.value })} rows="4" cols="20" id="" placeholder="your comment" />
                        <div className="remind_later">
                            {/* <a href="javascript:void(0)" id="remindLater" className="remind">Remind me later</a>  */}
                            <a id="getRating" className="send_btn">Send</a>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

